function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#babed1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b1b6cb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#babed1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9399b5"
})));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7095",
  "data-name": "Ellipse 7095",
  cx: 100,
  cy: 100,
  r: 100,
  fill: "#eaeaf3"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_35395",
  "data-name": "Group 35395"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7096",
  "data-name": "Ellipse 7096",
  cx: 23.694,
  cy: 23.694,
  r: 23.694,
  transform: "translate(33.334 99.185)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_63410",
  "data-name": "Path 63410",
  d: "M60.645,125a8.655,8.655,0,1,0-7.236,0,17.4,17.4,0,0,0-13.537,14.194,23.629,23.629,0,0,0,34.31,0A17.4,17.4,0,0,0,60.645,125Z",
  fill: "#969bb7"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_35396",
  "data-name": "Group 35396"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7097",
  "data-name": "Ellipse 7097",
  cx: 23.694,
  cy: 23.694,
  r: 23.694,
  transform: "translate(119.278 99.185)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_63411",
  "data-name": "Path 63411",
  d: "M146.589,125a8.655,8.655,0,1,0-7.236,0,17.4,17.4,0,0,0-13.537,14.194,23.629,23.629,0,0,0,34.31,0A17.4,17.4,0,0,0,146.589,125Z",
  fill: "#969bb7"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_35397",
  "data-name": "Group 35397"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7098",
  "data-name": "Ellipse 7098",
  cx: 42.03,
  cy: 42.03,
  r: 42.03,
  transform: "translate(57.97 41.91)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_63412",
  "data-name": "Path 63412",
  d: "M106.416,87.7a15.352,15.352,0,1,0-12.832,0,30.871,30.871,0,0,0-24.013,25.178,41.913,41.913,0,0,0,60.86,0A30.877,30.877,0,0,0,106.416,87.7Z",
  fill: "url(#linear-gradient-3)"
}));

var SvgCustomerGroup = function SvgCustomerGroup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "customer_group",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomerGroup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customer-group.5c469219.svg";
export { ForwardRef as ReactComponent };